import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { DataManagementService } from "../../data-management/data-management.service";
import { Group, Vehicule } from "../../../model/data-managemnt";
import {
  DeviceCarb,
  DeviceOpt,
  ExportRepFuelVariation, FuelingData,
  RepFuelVariation,
  TechnicalData
} from "../../../model/technical-data";
import { TechnicalDataService } from "../technical-data.service";
import { SigninService } from "../../../signin/signin.service";
import * as moment from 'moment';
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { User } from "../../../signin/credentials";
import { ToastrService } from "ngx-toastr";
import { UNIT_Array, Unit } from '../graph';
import { GeocodingService } from "../../../utils/leaflet/service/geocoding.service";
import * as Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);
import HichartsExportingData from 'highcharts/modules/export-data';
HichartsExportingData(Highcharts);
import { formatDate } from '@angular/common';
import * as L from 'leaflet';
import { ModalDirective } from "ngx-bootstrap/modal";
import { MapService } from "../../../utils/leaflet/service/map.service";
import { Icon, Marker } from "leaflet";
import { Router } from "@angular/router";
import { saveAs as importedSaveAs } from "file-saver";
import { StateService, ZoomState } from 'src/app/utils/leaflet/service/state.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-fuel-data',
  templateUrl: './fuel-data.component.html',
  styleUrls: ['./fuel-data.component.scss'],
})

export class FuelDataComponent implements OnInit {
  @ViewChild('mapModal') public mapModal: ModalDirective;
  @ViewChild('cardHeader', { static: false }) cardHeader: ElementRef;
  @ViewChild('targetElement', { static: false }) targetElement: ElementRef;

  setDynamicTopPosition() {
    const cardHeaderHeight = this.cardHeader.nativeElement.offsetHeight;
    this.targetElement.nativeElement.style.top = `${cardHeaderHeight}px`;
  }

  ngAfterViewInit() {
    this.setDynamicTopPosition();
  }
  formNotShown: boolean = false;
  isResultLoaded: boolean = true;
  //MultiSelelct vars
  dropdownList = [];
  selectItems: any = [];
  dropdownSettings = {};
  //Device Options
  deviceopt: DeviceOpt;
  optionsItems: any = [];
  optionsItemsen: any = [];
  optionsItemsar: any = [];

  selectedOptionItems: { item_text: string; item_id: number }[] = [];
  // selected: any = { startDate: new Date(), endDate: new Date() };

  selected: any = {
    startDate: new Date(new Date().setHours(0, 0, 0, 0)+ (60 * 60 * 1000)).toISOString(),
    endDate: new Date(new Date().setHours(23, 59, 59, 999)+ (60 * 60 * 1000)).toISOString(),
  };

  ranges: any = {
    'Aujourd hui': [moment().startOf('day'), moment().endOf('day')],
    'Hier': [moment(new Date()).subtract(1, 'days').startOf('day'), moment(new Date()).subtract(1, 'days').endOf('day')],
    'Les 7 derniers jours': [moment(new Date()).subtract(6, 'days').startOf('day'), moment(new Date()).endOf('day')],
    'Les 30 derniers jours': [moment(new Date()).subtract(29, 'days').startOf('day'), moment(new Date()).endOf('day')],
    'Ce mois-ci': [moment(new Date()).startOf('month').startOf('day'), moment(new Date()).endOf('month').endOf('day')],
    'Le mois dernier': [moment(new Date()).subtract(1, 'month').startOf('month').startOf('day'), moment(new Date()).subtract(1, 'month').endOf('month').endOf('day')]
  }
  optionsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  variationList: ExportRepFuelVariation[] = [];
  series: any[];
  useFuel: boolean = false;
  //Device Carburant
  devicecarb: DeviceCarb;
  volume: number;
  repFuelVariation: RepFuelVariation[] = [];
  technicaldata: TechnicalData[];
  public currentUser: User = new User();
  carburantSeries: any[] = [];
  carburantCategorie: any[] = [];
  fuelingData: FuelingData[];
  options: any;
  optionsCarburant: any;
  isGroupLoaded = false;


  constructor(
    private stateservice :StateService,
    private router: Router,
    public dataManagementService: DataManagementService,
    public technicaldataservice: TechnicalDataService,
    public signinService: SigninService,
    public geocodingService: GeocodingService,
    public toastr: ToastrService,
    private mapService: MapService,
    private technicalDataService: TechnicalDataService,
    public translate: TranslateService,
  ) { }

  ngOnInit() {
    // this.mapService.mapToTop = false
    // this.mapService.mapToRight = false
    // this.mapService.mapFullscreen = true
    //init multiselect
   /* if (!this.dataManagementService.vehicules) {
      this.router.navigate(['client']);
    }*/
    this.router.navigate(['carburant']);

      this.mapService.animatedMarker = null;

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select option",
      selectAllText: 'Select Tous',
      unSelectAllText: 'UnSelect Tous',
      enableSearchFilter: false,
      classes: "custom-class-multiselect",
      badgeShowLimit: 1
    };
    this.dataManagementService.selectedGroup = this.dataManagementService.groups[0];
    this.dataManagementService.selectedVehicule = this.dataManagementService.groups[0].vehicules[0];
    this.dataManagementService.GroupsLoaded$.subscribe(groups => this.onGroupLoaded(groups));
    this.dataManagementService.init();
    if (this.dataManagementService.selectedVehicule)
      this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
  }
  ngOnDestroy() {
  }

  ionViewWillEnter() {
    
    
  }

  ionViewDidEnter() {
    this.mapService.animatedMarker = null;
  }
  ionViewWillLeave() {
    if (this.mapService.map) {
      this.mapService.map.remove();
    }  }

  dateHandle(event: any, type: string) {
    console.log(event);
    // Update the selected.startDate with the new value
    if (type === 'start') {
      this.selected.startDate = event.detail.value;
    } else {
      this.selected.endDate = event.detail.value;
    }
  }

  onGroupLoaded(groups: Group[]) {
    if (this.dataManagementService.groups) {
      this.isGroupLoaded = true;
      if (this.dataManagementService.selectedVehicule)
        this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
    }
  }

  chooseGroup(group) {
    this.dataManagementService.selectedGroup = group;
    if (this.dataManagementService?.selectedGroup!.vehicules.length > 0 && this.dataManagementService.selectedGroup) {
      this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
      this.selectItems = [];
    }
  }

  chooseVehicule(vehicule: Vehicule) {
    this.dataManagementService.selectedVehicule = vehicule;
    this.getDeviceOpt(this.dataManagementService?.selectedVehicule!.device.idDevice);
    this.selectItems = [];
  }
  deleteItemById(itemId) {
    this.optionsItems = this.optionsItems.filter(item => item.item_id !== itemId);
    this.optionsItemsen = this.optionsItemsen.filter(item => item.item_id !== itemId);
    this.optionsItemsar = this.optionsItemsar.filter(item => item.item_id !== itemId);
  }
  getDeviceOpt(deviceid: number) {
    this.dropdownList = [];
    this.selectedOptionItems = [];
    this.optionsItems = {
      'fr': [
        { "item_id": 0, "item_text": "Ignition" },
        { "item_id": 1, "item_text": "Carburant" },
        { "item_id": 2, "item_text": "Carburant Total" },
        { "item_id": 3, "item_text": "ODOMETRE" },
        { "item_id": 4, "item_text": "Vitesse" },
        { "item_id": 5, "item_text": "Carburant filtré" },
        { "item_id": 6, "item_text": "TFU algorithmique" }
      ],
      'en': [
        { "item_id": 0, "item_text": "Ignition" },
        { "item_id": 1, "item_text": "Fuel" },
        { "item_id": 2, "item_text": "Total Fuel" },
        { "item_id": 3, "item_text": "ODOMETRE" },
        { "item_id": 4, "item_text": "Speed" },
        { "item_id": 5, "item_text": "Filtered fuel" },
        { "item_id": 6, "item_text": "Algorithmic TFU" }
      ],
      'ar': [
        { "item_id": 0, "item_text": "اشتعال" },
        { "item_id": 1, "item_text": "وقود" },
        { "item_id": 2, "item_text": "إجمالي الوقود" },
        { "item_id": 3, "item_text": "عداد المسافات" },
        { "item_id": 4, "item_text": "سرعة" },
        { "item_id": 5, "item_text": "الوقود المفلتر" },
        { "item_id": 6, "item_text": "TFU الخوارزمي" }
      ]
    };
    
    this.isResultLoaded = false;
    this.technicaldataservice.getDeviceOpt(deviceid).subscribe(response => {
      this.deviceopt = response;
      if (this.deviceopt.useIgnition == 0) {
        this.deleteItemById(0);
        // this.dropdownList.push({ "id": 0, "option": "ignition", "itemName": "Ignition" })
      }
      if (this.deviceopt.useFuel == 0 && this.deviceopt.useFms == 0 && this.deviceopt.useJ1708 == 0) {
        this.deleteItemById(1);
        // this.dropdownList.push({ "id": 1, "option": "fuel", "itemName": "Carburant" })
      }
      if (this.deviceopt.useFms == 0 && this.deviceopt.useJ1708 == 0) {
        this.deleteItemById(2);
        this.deleteItemById(3);
        // this.dropdownList.push({ "id": 2, "option": "tfu", "itemName": "Carburant Total" }),
        //   this.dropdownList.push({ "id": 3, "option": "accum_odo", "itemName": "ODOMETRE" })
      }
      // this.dropdownList.push({ "id": 4, "option": "speed", "itemName": "Vitesse" })
      // this.dropdownList.push({ "id": 5, "option": "carb_filtred_carb_value", "itemName": "Carburant filtré" })
      // this.dropdownList.push({ "id": 6, "option": "carb_alg_tfu", "itemName": "TFU algorithmique" })
      this.isResultLoaded = true;
    })
  }
  formatDate(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    // Add leading zero if day or month is single digit
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return `${day}/${month}/${year}`;
  }
  displayChart() {
    console.log(this.selected);
    this.selectItems = [];
    this.selectedOptionItems.forEach(item => {
      const itemMapping = {
        0: { "id": 0, "option": "ignition", "itemName": "Ignition" },
        1: { "id": 1, "option": "fuel", "itemName": "Carburant" },
        2: { "id": 2, "option": "tfu", "itemName": "Carburant Total" },
        3: { "id": 3, "option": "accum_odo", "itemName": "ODOMETRE" },
        4: { "id": 4, "option": "speed", "itemName": "Vitesse" },
        5: { "id": 5, "option": "carb_filtred_carb_value", "itemName": "Carburant filtré" },
        6: { "id": 6, "option": "carb_alg_tfu", "itemName": "TFU algorithmique" }
      };
      if (itemMapping[item.item_id]) {
        this.selectItems.push(itemMapping[item.item_id]);
      }
    });
    console.log(this.selectItems);
    //Get Selected Options
    let devopt: any = [];
    let devcarbopt: any = [];
    //this.yaxis = [];
    this.series = [];
    if (this.selectItems.length > 0) {
      this.useFuel = false;
      this.selectItems.forEach(itm => {
        if (itm.option == "fuel") {
          this.useFuel = true;
        }
        if (itm.option.startsWith("carb_")) {
          devcarbopt.push(itm.option.substring(5));
        } else {
          devopt.push(itm.option);
        }
      })
    }
    // Options vars
    let fuel: any = [];
    let ignition: any = [];
    let tfu: any = [];
    let accum_odo: any = [];
    let speed: any = [];
    let alg_tfu: any = [];
    let filtred_carb_value: any = [];
    this.variationList = [];
    //Select data Device carburant
    this.technicaldataservice.getDeviceCarb(this.dataManagementService?.selectedVehicule!.device.idDevice).subscribe(res => {
      this.devicecarb = res;
      this.volume = this.devicecarb.volume;
      this.technicaldataservice.getRepFuelVariation(this.dataManagementService?.selectedVehicule!.device.idDevice, {
        startDate: this.selected.startDate,
        endDate: this.selected.endDate
      }).subscribe(res => {
        this.repFuelVariation = res;
        this.refreshApproTable();
      });
    });
    let flags: any = [];
    //Get Fuel Data and fill all options
    this.technicaldataservice.getFuelDetail(this.dataManagementService?.selectedVehicule!.device.idDevice, {
      startDate: this.selected.startDate,
      endDate: this.selected.endDate
    }, devopt).subscribe(res => {
      this.technicaldata = res;
      this.currentUser = JSON.parse(localStorage.getItem("currentUser") || '{}');
      if (this.currentUser.username === 'clc') {
        this.carburantSeries = [];
        this.carburantCategorie = [];
        this.carburantSeries.push({ name: 'Consommation Moyenne', data: [] });
        let periods: Date[] = []
        periods = this.getWeekStartDates(this.selected);
        periods.forEach((period, index) => {
          let periodStart = period;
          let periodEnd = new Date(periodStart);
          periodEnd.setDate(periodEnd.getDate() + 7); // Calculate end date by adding 7 days
          // If it's the last period, adjust the end date to the actual end date
          if (index === periods.length - 1) {
            periodEnd = new Date(this.selected.endDate);
          }
          // Filter technicaldata for the current period
          let dataFuel: TechnicalData[] = [];
          dataFuel = this.technicaldata.filter(technical => {
            const technicalDate = new Date(technical.date);
            // Add one hour to the technical date
            technicalDate.setHours(technicalDate.getHours() + 1);
            // Check if the technical data falls within the period
            return technicalDate >= periodStart && technicalDate < periodEnd;
          });
          console.log(dataFuel);
          let approFuel: ExportRepFuelVariation[] = [];
          approFuel = this.variationList.filter(repFuel => {
            const repFuelDate = new Date(repFuel.approStartTime);
            // Add one hour to the technical date
            repFuelDate.setHours(repFuelDate.getHours() + 1);
            // Check if the technical data falls within the period
            return repFuelDate >= periodStart && repFuelDate < periodEnd;
          })
          let odoMetreStart = 0;
          let odoMetreEnd = 0;
          let accumFuel = 0;
          odoMetreStart = dataFuel[0]?.accum_odo
          odoMetreEnd = dataFuel[dataFuel.length - 1]?.accum_odo
          for (let appro of approFuel) {
            accumFuel += appro.avConso;
          }
          if (approFuel.length === 0) {
            for (let i = 1; i < dataFuel.length; i++) {
              accumFuel += Math.abs(dataFuel[i - 1].fuel - dataFuel[i].fuel)
            }
          }
          this.carburantCategorie.push(`${this.formatDate(new Date(periodStart))} - ${this.formatDate(new Date(periodEnd))} Distance: ${odoMetreEnd - odoMetreStart}km`);
          if (approFuel.length !== 0) {
            this.carburantSeries[0].data.push(Number((accumFuel / approFuel.length).toFixed(2)));
          } else {
            this.carburantSeries[0].data.push(Number((accumFuel / (odoMetreEnd - odoMetreStart)).toFixed(2)));
          }
        });
      }
      this.technicaldataservice.getListFuelingDate(this.dataManagementService?.selectedVehicule!.idVehicule, this.selected.startDate, this.selected.endDate).subscribe(resFueling => {
        let i = 0;
        this.fuelingData = [];
        let fuelingDataDisp: any = [];
        for (let fueling of resFueling) {
          this.fuelingData[i] = new FuelingData();
          this.fuelingData[i].quantity = fueling.quantity;
          this.fuelingData[i].operationTime = fueling.operationTime;
          this.fuelingData[i].address = fueling.place;
          this.fuelingData[i].offset = this.setOffsetForFueling(this.dataManagementService?.selectedVehicule!, this.fuelingData[i], this.repFuelVariation);
          fuelingDataDisp.push([this.fuelingData[i].operationTime, this.fuelingData[i].offset, this.fuelingData[i].offset + this.fuelingData[i].quantity]);
          let variation: ExportRepFuelVariation = new ExportRepFuelVariation();
          variation.time = fueling.operationTime;
          variation.qty = fueling.quantity;
          variation.odo = fueling.odometre;
          variation.type = "PARC";
          variation.address = fueling.place;
          this.variationList.push(variation);
          i++;
        }

        this.variationList.sort((function (a, b) {
          if (a.time && b.time)
            return new Date(b.time).getTime() - new Date(a.time).getTime();
          return 0;
        }));
        if (this.technicaldata.length == 0) {
          this.toastr.warning("Pas de données à afficher");
        }
        this.technicaldata.forEach(stat => {
          if (stat.fuel != undefined) {
            if (this.devicecarb.max - this.devicecarb.min > 0) {
              if ((stat.fuel >= this.devicecarb.min) && (stat.fuel <= this.devicecarb.max)) {
                fuel.push({
                  "x": stat.date,
                  "y": ((stat.fuel - this.devicecarb.min) / (this.devicecarb.max - this.devicecarb.min) * this.devicecarb.volume)
                });
              }
            } else {
              if ((stat.fuel >= this.devicecarb.max) && (stat.fuel <= this.devicecarb.min)) {
                fuel.push({
                  "x": stat.date,
                  "y": ((stat.fuel - this.devicecarb.min) / (this.devicecarb.max - this.devicecarb.min) * this.devicecarb.volume)
                });
              }
            }
          }
          if (stat.ignition != undefined) {
            ignition.push({ "x": stat.date, "y": stat.ignition ? 1 : 0 });
          }
          if (stat.tfu != undefined) {
            tfu.push({ "x": stat.date, "y": stat.tfu });
          }
          if (stat.accum_odo != undefined) {
            accum_odo.push({ "x": stat.date, "y": stat.accum_odo + this.dataManagementService?.selectedVehicule!.odoOffset });
          }
          if (stat.speed != undefined) {
            speed.push({ "x": stat.date, "y": stat.speed });
          }

        });

        for (let i = 1; i < ignition.length; i++) {
          if (ignition[i].y > ignition[i - 1].y || ignition[i].y < ignition[i - 1].y) {
            ignition[i].x = ignition[i - 1].x;
          }
        }
        for (let fueling of this.fuelingData) {
          flags.push({
            type: 'flags',
            data: [{
              x: fueling.operationTime,
              title: 'Appro Parc'
            }],
            linkedTo: 'dataseries',
            onSeries: 'dataseries',
            shape: 'flag',
            showInLegend: false,
            color: 'rgb(0, 0, 255)',
            fillColor: 'rgb(0, 0, 255)',

            y: 30
          })
        }
        //Flags
        for (let j = 0; j < this.repFuelVariation.length; j++) {
          for (let i = 1; i < fuel.length; i++) {
            if (fuel[i - 1].x == this.repFuelVariation[j].approStartTime && this.repFuelVariation[j].type == "APPRO") {
              flags.push({
                type: 'flags',
                data: [{
                  x: fuel[i].x,
                  title: 'Appro',
                  text: 'Appro Level: ' + (this.repFuelVariation[j].approEndFuelLevel - this.repFuelVariation[j].approStartFuelLevel)
                }],
                linkedTo: 'dataseries',
                onSeries: 'dataseries',
                shape: 'flag',
                showInLegend: false,
                color: 'rgb(44, 161, 33)',
                fillColor: 'rgb(44, 161, 33)'
              })
            }
            else if (fuel[i - 1].x == this.repFuelVariation[j].approStartTime && this.repFuelVariation[j].type == "THIEF") {
              flags.push({
                type: 'flags',
                data: [{
                  x: fuel[i].x,
                  title: 'Diminution',
                  text: 'Appro Level: ' + (this.repFuelVariation[j].approEndFuelLevel - this.repFuelVariation[j].approStartFuelLevel)
                }],
                linkedTo: 'dataseries',
                onSeries: 'dataseries',
                shape: 'flag',
                showInLegend: false,
                color: 'rgb(230, 20, 9)',
                fillColor: 'rgb(230, 20, 9)'
              })
            }
          }
        }

        //Fill all series and yxais
        if (this.ChartSeries(ignition)) {
          this.series.push({
            name: 'Ignition', type: 'area', color: 'rgb(255, 127, 0)',
            data: ignition,
            yAxis: UNIT_Array.indexOf(Unit.NONE),
          })

        }
        if (this.ChartSeries(speed)) {
          this.series.push({
            name: 'Speed', data: speed,
            color: 'rgb(68,169,168)',
            yAxis: UNIT_Array.indexOf(Unit.KMH),
            tooltip: {
              valueSuffix: "KM/H",
              valueDecimals: 2
            },
          });
        }
        if (this.ChartSeries(fuel)) {
          console.log(fuel);
          this.series.push({

            name: 'Carburant', data: fuel,
            id: 'dataseries',
            color: 'rgb(23, 119, 182)',
            yAxis: UNIT_Array.indexOf(Unit.LITRE),
            tooltip: {
              valueSuffix: "L",
              valueDecimals: 2
            }
          }, {
            id: "parcSerie",
            name: 'Fuel PARC',
            linkedTo: 'dataseries',
            type: 'errorbar',
            yAxis: UNIT_Array.indexOf(Unit.LITRE),
            data: fuelingDataDisp,
            color: 'rgb(0, 0, 0)',
            lineWidth: 5
          }
          );
          flags.forEach(flag => {
            this.series.push(flag);
          })
        }
        if (this.ChartSeries(tfu)) {
          this.series.push({
            name: 'Carburant Total', data: tfu,
            yAxis: UNIT_Array.indexOf(Unit.LITRE_TFU),
            color: 'rgb(107, 57, 156)',
            tooltip: {
              valueSuffix: "L",
              valueDecimals: 2
            },
          });
        }
        if (this.ChartSeries(accum_odo)) {
          this.series.push({
            yAxis: UNIT_Array.indexOf(Unit.KM),
            name: 'odomètre', data: accum_odo,
            color: 'rgb(44, 161, 33)',
            tooltip: {
              valueSuffix: "KM",
              valueDecimals: 2
            },
          });
        }

        this.refreshChart(this.series, this.loadYAxis());
      });

    });


    this.technicaldataservice.getFuelDetailCarb(this.dataManagementService?.selectedVehicule!.device.idDevice, {
      startDate: this.selected.startDate,
      endDate: this.selected.endDate
    }, devcarbopt).subscribe(res => {
      this.technicaldata = res;
      this.technicaldata.forEach(stat => {
        if (stat.alg_tfu != undefined) {
          alg_tfu.push({ "x": stat.date, "y": stat.alg_tfu });
        }
        if (stat.filtred_carb_value != undefined) {
          filtred_carb_value.push({ "x": stat.date, "y": stat.filtred_carb_value });
        }
      }

      );
      if (this.ChartSeries(alg_tfu)) {
        this.series.push({
          name: 'TFU algorithmique', data: alg_tfu,
          color: 'rgb(23, 119, 182)',
          yAxis: UNIT_Array.indexOf(Unit.LITRE_TFU),
          tooltip: {
            valueSuffix: "L",
            valueDecimals: 2
          }
        });
      }
      if (this.ChartSeries(filtred_carb_value)) {
        this.series.push({
          name: 'carburant filtré', data: filtred_carb_value,
          color: 'rgb(23, 119, 182)',
          yAxis: UNIT_Array.indexOf(Unit.LITRE),
          tooltip: {
            valueSuffix: "L",
            valueDecimals: 2
          }
        });
      }
      this.refreshChart(this.series, this.loadYAxis());
    });
    this.formNotShown = true;
  }

  refreshApproTable() {
    for (let i = 0; i < this.repFuelVariation.length; i++) {
      let variation: ExportRepFuelVariation = new ExportRepFuelVariation;
      variation.deviceId = this.dataManagementService?.selectedVehicule!.device.idDevice;
      variation.approStartTime = this.repFuelVariation[i].approStartTime;
      variation.approEndTime = this.repFuelVariation[i].approEndTime;

      variation.type = this.repFuelVariation[i].type;
      if (this.devicecarb != undefined) {
        variation.startLevel = Math.round(((this.repFuelVariation[i].approStartFuelLevel) / 100) * this.devicecarb.volume);

        variation.qty = Math.round((((this.repFuelVariation[i].approEndFuelLevel - this.repFuelVariation[i].approStartFuelLevel) / 100) * this.devicecarb.volume + (this.repFuelVariation[i].approEndTfu - this.repFuelVariation[i].approStartTfu)));
        if (variation.type == "APPRO")
          variation.endLevel = variation.startLevel + variation.qty;
        else
          variation.endLevel = Math.round(((this.repFuelVariation[i].approEndFuelLevel) / 100) * this.devicecarb.volume);
        variation.odo = this.repFuelVariation[i].approStartOdo + this.dataManagementService?.selectedVehicule!.odoOffset;
        variation.avConso = Math.floor(((((this.repFuelVariation[i].consumeStartFuelLevel - this.repFuelVariation[i].approStartFuelLevel) / (this.repFuelVariation[i].approStartOdo - this.repFuelVariation[i].consumeStartOdo)) * 100) / 100 * this.devicecarb.volume) * 10) / 10;
        if (i != this.repFuelVariation.length - 1)
          variation.distance = this.repFuelVariation[i].approStartOdo - (this.repFuelVariation[i + 1].approStartOdo);
        else
          variation.distance = 0;
        variation.time = this.repFuelVariation[i].approStartTime;
      }
      this.technicaldataservice.getFuelDetail(this.dataManagementService?.selectedVehicule!.device.idDevice, {
        startDate: this.repFuelVariation[i].approStartTime,
        endDate: this.repFuelVariation[i].approEndTime
      }, ["latitude", "longitude"]).subscribe(res => {
        if (res[0] != undefined) {
          variation.address = this.dataManagementService.getRelativePosition(
            res[0].latitude,
            res[0].longitude
          );
        }

        if (variation.address == null) {
          if (res[0] != undefined) {
            // if (owner == 'CLICK') {
            //   this.geocodingService.inverseGeocondingAddok(res[0].latitude, res[0].longitude).subscribe(adress => {
            //     variation.address = adress.display_name;
            //   });
            // } else {
            this.geocodingService.inverseGeoconding(res[0].latitude, res[0].longitude, 7).subscribe(adress => {
              variation.address = adress.display_name;
            });
            // }
          }
        }

      })

      this.variationList.push(variation);
    }
    console.log(this.variationList);
  }
  getWeekStartDates(selected: any): Date[] {
    const periods: Date[] = [];

    if (!selected.startDate || !selected.endDate) {
      return periods;
    }

    let currentDate = new Date(selected.startDate);
    const endDate = new Date(selected.endDate);

    // Add the first start date
    currentDate.setHours(currentDate.getHours() + 1);
    periods.push(new Date(currentDate));

    // Loop until the current date is before or equal to the end date
    while (currentDate <= endDate) {
      // Move to the next week
      currentDate.setDate(currentDate.getDate() + 7);

      // Add one hour
      currentDate.setHours(currentDate.getHours() + 1);

      // Push the start of the next week to the periods array
      if (currentDate <= endDate) {
        periods.push(new Date(currentDate));
      }
    }

    return periods;
  }

  setOffsetForFueling(vehicule: Vehicule, fueling: FuelingData, repFuelVariations: RepFuelVariation[]): number {
    let variationsIndex = 0;
    for (let rep of repFuelVariations) {
      if (fueling.operationTime > rep.consumeStartTime && fueling.operationTime < rep.approEndTime) {
        return rep.approStartFuelLevel * vehicule.device.carb.volume / 100;
      }
    }
    return 0;
  }
  //check if the series is empty or not
  ChartSeries(data: any = []) {
    let ok: boolean;
    data.forEach(dt => {
      ok = dt.y == undefined ? false : true;
    });
    // @ts-ignore
    return ok;
  }

  refreshChart(series: any[], yaxiss: any[]) {

    this.options = new Highcharts.Chart({
      title: { text: "Véhicule: " + (this.dataManagementService.selectedVehicule?.matricule ?? '') },
      chart: {
        type: 'spline',
        renderTo: 'container',

        //v14zoomType: 'x'
      },

      xAxis: [{
        type: 'datetime',
        tickInterval: 3600 * 1000,
        labels: {
          formatter: function () {
            //return Highcharts.dateFormat('%d/%m/%Y %H:%M', Number(this.value));

            return formatDate(
              this.value,
              'dd/MM/yyyy, HH:MM',
              'en-US'
            );
          }
        },
        crosshair: true
      }],

      yAxis: this.loadYAxis(),

      plotOptions: {
        series: {
          turboThreshold: 100000,
          events: {
            click: (event) => {
              this.getPathDatails(this.dataManagementService.selectedVehicule!.device.idDevice, event.point.x, event.point.x)
            },
          },
        }
      },

      series: series,


    });
    this.optionsCarburant = new Highcharts.Chart({
      // Chart Title: Displayed as "Véhicule: [Vehicle Matricule]".
      title: { text: "Véhicule: " + this.dataManagementService?.selectedVehicule?.matricule },
      // Chart Rendering Options.
      chart: {
        // Chart Type: Set to 'spline' for spline chart.
        type: 'column',
        // Chart Rendering: Rendered within the div with id 'container'.
        renderTo: 'container-carburant',
        // Zoom Type: Enable zooming along the x-axis.
        //v 14 zoomType: 'x'
      },
      // X-Axis Parameters.
      xAxis: [{
        // Data Type: Date and time.
        type: 'category',
        categories: this.carburantCategorie,
        // tickInterval: 3600 * 1000,
        labels: {
        },
        crosshair: true
      }],
      yAxis: {
        title: {
          text: 'Litre'
        }
      },
      plotOptions: {
        series: {
          turboThreshold: 100000,
        }
      },
      series: this.carburantSeries
    });
    console.log(this.carburantSeries)
    console.log(this.carburantCategorie)
  }
  private loadYAxis(): any[] {
    let yAxisArray: any = [];
    UNIT_Array.forEach((unit, index) => {
      let yaxis = {
        labels: {
          format: '{value} ' + unit
        },
        title: {
          text: null
        },
        opposite: index % 2 == 0
      };
      yAxisArray.push(yaxis);
    });
    return yAxisArray;
  }

  public showChildModal(): void {
    this.mapModal.show();
  }
  onMapReady(map) {
    setTimeout(() => {
      map.invalidateSize(true)
    }, 300)
  }

  getPathDatails(idDevice: number, dateD: any, dateF: any) {
    let options: any = [];
    var data: any;
    let popup = "<span class='leaflet-pelias-layer-icon-container'><div class='leaflet-pelias-layer-icon leaflet-pelias-layer-icon-point' title='layer: venue'></div></span> ";
    options.push('ignition')
    options.push('latitude')
    options.push('longitude')
    let marker: any = null;
    document.getElementsByClassName("leaflet-fullscreen-on")[0].setAttribute('style',
      'z-index:44; width: 98.2% !important; height: 88.5% !important; margin-left: 8px !important; margin-top: 52px !important;');
    this.showChildModal();

    //this.mapService.map.invalidateSize();
    if (this.mapService.map) this.mapService.map.remove();
    let map;

    // if (template == "finek") {
    //   let optionsSpec: any = {
    //     zoomControl: false,
    //     center: L.latLng(36.850457, 10.225097),
    //     zoom: 6,
    //     minZoom: 3,
    //     maxZoom: 20,
    //     maxNativeZoom: 17,
    //     layers: [this.mapService.baseMapsFinek.OpenStreetMap]
    //   }
    //   map = L.map('map', optionsSpec);
    //   L.control.layers(this.mapService.baseMapsFinek, null, { position: 'bottomright' }).addTo(map);
    // } else {
    let optionsSpec: any = {
      zoomControl: false,
      center: L.latLng(36.850457, 10.225097),
      zoom: 6,
      minZoom: 3,
      maxZoom: 20,
      maxNativeZoom: 17,
      layers: [this.mapService.baseMaps.OpenStreetMap]
    }
    map = L.map('map', optionsSpec);
    L.control.layers(this.mapService.baseMaps, undefined, { position: 'bottomright' }).addTo(map);
    // }

    L.control.zoom({ position: 'bottomright' }).addTo(map);
    this.mapService.map = map;


    this.technicaldataservice.getFuelDetail(idDevice, {
      startDate: dateD,
      endDate: dateF
    }, options).subscribe(resp => {
      console.log(resp)
      data = resp[0];
      marker = new Marker([data.latitude, data.longitude]);

      this.geocodingService.inverseGeoconding(data.latitude, data.longitude, 7).subscribe(adress => {

        popup = popup + ' <b>' + adress.display_name + '</b><br>';
        marker.bindPopup(popup);
      });

      marker.on("mouseover", () => {
        marker.openPopup();
      });

      if (data.ignition) {
        marker.setIcon(new Icon({
          iconUrl: "http://fleet.tn/images/c1x0.png",
          iconSize: [40, 40],
          shadowSize: [40, 40],
          iconAnchor: [20, 20],
          shadowAnchor: [20, 20],
          popupAnchor: [10, -10]
        }));
      } else {
        marker.setIcon(new Icon({
          iconUrl: "http://fleet.tn/images/c3x0.png",
          iconSize: [40, 40],
          shadowSize: [40, 40],
          iconAnchor: [20, 20],
          shadowAnchor: [20, 20],
          popupAnchor: [10, -10]
        }));
      }
      this.stateservice.setSelectedMarker(data);
      this.stateservice.updateState(ZoomState.DisplayPath);
      //this.mapService.map.setView([data.latitude, data.longitude], 9);
      this.mapService.addMarker(marker);
      this.onMapReady(this.mapService.map)

    })
  }


  exportFuelsData() {
    let vehicule = this.dataManagementService.getMatriculeByDeviceId(
      this.dataManagementService?.selectedGroup!,
      this.dataManagementService?.selectedVehicule!.device.idDevice
    );

    let fuelsDataToExport = this.variationList.slice();
    this.technicalDataService.exportFuelsData(
      fuelsDataToExport,
      this.dataManagementService?.selectedGroup!.nom,
      this.selected.startDate,
      this.selected.endDate,
      vehicule
    ).subscribe(
      blob => {
        if (blob.size != 0) importedSaveAs(blob, "template_report_consommation.xlsx");
      }
      ,
      () => {
        this.toastr.error("aucune données entre ces deux dates !", "Error");
      }
    );
  }
  close() {
    console.log('Close function called');
    this.router.navigate(['/client']);
  }
  protected readonly event = event;
}
